export default __webpack_public_path__ + "static/media/modal-checkmark@3x.aca1ea72.png";